const BO_URL = process.env.REACT_APP_LEMOULIN_BO_URL;

/**
 * Construit l'URL publique d'un média de suggestion (chemin relatif renvoyé par
 * l'API, préfixé par l'URL du BO).
 */
export const mediaUrl = (media) => {
  if (!media) return null;
  const path = media.square || media.path;
  if (!path) return null;
  return path.indexOf("http") === 0 ? path : `${BO_URL}/${path}`;
};
